// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import Vue from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { setupAxiosInterceptors } from "@/shared/config/axios-interceptor";

import App from "./app.vue";
import Vue2Filters from "vue2-filters";
import { BootstrapVue, BootstrapVueIcons, ToastPlugin } from "bootstrap-vue";
import router from "./router";
import * as config from "./shared/config/config";
import * as bootstrapVueConfig from "./shared/config/config-bootstrap-vue";
import JhiItemCountComponent from "./shared/jhi-item-count.vue";
import JhiSortIndicatorComponent from "./shared/sort/jhi-sort-indicator.vue";
import InfiniteLoading from "vue-infinite-loading";
import HealthService from "./admin/health/health.service";
import MetricsService from "./admin/metrics/metrics.service";
import LogsService from "./admin/logs/logs.service";
import ConfigurationService from "@/admin/configuration/configuration.service";
import LoginService from "./account/login.service";
import AccountService from "./account/account.service";
import AlertService from "./shared/alert/alert.service";
import vuetify from "./shared/config/vuetify";

import "../content/scss/global.scss";
import "../content/scss/vendor.scss";
import "leaflet/dist/leaflet.css";
/* tslint:disable */

// jhipster-needle-add-entity-service-to-main-import - JHipster will import entities services here

/* tslint:enable */
Vue.config.productionTip = false;
config.initVueApp(Vue);
config.initFortAwesome(Vue);
bootstrapVueConfig.initBootstrapVue(Vue);
Vue.use(Vue2Filters);
Vue.use(ToastPlugin);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('jhi-item-count', JhiItemCountComponent);
Vue.component('jhi-sort-indicator', JhiSortIndicatorComponent);
Vue.component('infinite-loading', InfiniteLoading);
const store = config.initVueXStore(Vue);

const loginService = new LoginService();
const accountService = new AccountService(store, (<any>Vue).cookie, router);

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

setupAxiosInterceptors(
  error => {
    const url = error.response?.config?.url;
    const status = error.status || error.response.status;
    if (status === 401) {
      // Trang /mobile/* xác thực bằng token trên URL, không có luồng đăng nhập web: đẩy sang
      // /login chỉ thay bản đồ bằng màn hình đăng nhập. Trả lỗi về để trang tự hiển thị.
      if (router.currentRoute.path.startsWith('/mobile/')) {
        return Promise.reject(error);
      }
      // Store logged out state.
      store.commit('logout');
      if (!url.endsWith('api/account') && !url.endsWith('api/authenticate')) {
        // Ask for a new authentication
        if (router.currentRoute.path !== '/login') {
          console.log('setupAxiosInterceptors, go to /login');
          return router.push('/login');
        }
        return;
      }
    }
    console.log('Unauthorized!');
    return Promise.reject(error);
  },
  error => {
    console.log('Server error!');
    return Promise.reject(error);
  }
);

router.beforeEach(async (to, from, next) => {
  if (!to.matched.length) {
    next('/');
  } else if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
    accountService.hasAnyAuthorityAndCheckAuth(to.meta.authorities).then(value => {
      if (!accountService.authenticated) {
        router.push('/login');
        return;
      }
      if (!value) {
        // router.push('/');
        sessionStorage.setItem('requested-url', to.fullPath);
        (router.app.$root as any).$bvToast.toast('Bạn không có quyền truy cập vào tài nguyên này', {
          toaster: 'b-toaster-top-center',
          title: 'Truy cập bị từ chối',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        });
      } else {
        next();
      }
    });
  } else {
    // no authorities, so just proceed
    next();
  }
});

/* tslint:disable */
const vue = new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  vuetify,
  router,
  provide: {
    loginService: () => loginService,
    healthService: () => new HealthService(),
    configurationService: () => new ConfigurationService(),
    logsService: () => new LogsService(),
    metricsService: () => new MetricsService(),

    // jhipster-needle-add-entity-service-to-main - JHipster will import entities services here
    accountService: () => accountService,
    alertService: () => new AlertService(),
  },
  store,
});
